import { Table } from "react-bootstrap";
import "../../../../common/styles/table.css";
import QuestTableRow from "./QuestTableRow";

/**
 * @typedef {import("../../../../hooks/teacher/students/useGetStudentReportById").QuestItem} QuestItem
 */

/**
 * @typedef {object} StudentType
 * @property {string} name
 * @property {string} studentId
 * @property {string | number} age
 * @property {string} email
 * @property {number} progress
 * @property {number} avgScore
 * @property {number} totalQuests
 */

/**
 * Quest Table Component
 * @param {{quests: QuestItem[], studentId: string | number, student: StudentType}} props
 */
const QuestTable = ({ quests, studentId, student }) => {
  if (!quests || quests.length === 0) {
    return (
      <div className="alert alert-info mt-3" role="alert">
        No quests found.
      </div>
    );
  }

  return (
    <div className="custom-table-container mt-3">
      <div className="custom-table-wrapper">
        <Table hover className="custom-table">
          <thead className="custom-table-head">
            <tr>
              <th>Quest</th>
              <th>Episodes</th>
              <th>Percentage</th>
              <th>Due Date</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {quests.map((quest) => {
              return (
                <QuestTableRow
                  key={quest.quest_id}
                  quest={quest}
                  studentId={studentId}
                  student={student}
                />
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default QuestTable;
